import {put, takeEvery} from "redux-saga/effects";
import {SizingRange} from "../../../Models/SizingRange";
import {localStorage} from "../../../lib/storages/localStorage";
import {sizingRangesGetError, sizingRangesGetSuccess} from "./actions";
import * as TYPES from "./types";

export default function* sizingRangesSagas() {
    yield takeEvery(TYPES.SIZING_RANGES_GET_REQUEST, sizingRangesGetRequest);
}

function* sizingRangesGetRequest(action) {
    try {
        let items = [];

        if (localStorage.getItem(TYPES.SIZING_RANGES_GET_REQUEST)) {
            items = localStorage.getItem(TYPES.SIZING_RANGES_GET_REQUEST);
        } else {
            const response = yield SizingRange.index({
                ...action.payload,
            });

            items = response.data.items;
            localStorage.setItem(TYPES.SIZING_RANGES_GET_REQUEST, items);
        }

        const data = {
            items: items,
            pagination: {total: 0, pages: 0},
        };

        yield put(
            sizingRangesGetSuccess({
                data,
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(sizingRangesGetError(error));
    }
}
